module.exports = __webpack_public_path__ + "static/media/Sq3.b2061b9f.svg";